module.exports = __webpack_public_path__ + "img/top1.bd90a05e.png";